import { useClient } from '../supabase/client'

const ALLOWED_ABSOLUTE_FILE_HOSTS = ['ui-avatars.com']

const parseAbsoluteUrl = (url: string) => {
   try {
      return new URL(url)
   } catch {
      return null
   }
}

const isAllowedAbsoluteFileUrl = (parsed: URL) => {
   if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false

   const host = parsed.hostname.toLowerCase()
   if (ALLOWED_ABSOLUTE_FILE_HOSTS.includes(host)) return true

   const storageHost = parseAbsoluteUrl(useRuntimeConfig().public.supabase.url)?.hostname
   return !!storageHost && host === storageHost.toLowerCase()
}

export const getFileUrlFromBucket = (url?: string | null) => {
   const client = useClient()

   if (!url) return ''

   const parsed = parseAbsoluteUrl(url)
   if (parsed) return isAllowedAbsoluteFileUrl(parsed) ? url : ''

   const [bucket, ...path] = url.split('/')
   if (!bucket || !path.length) return ''

   const { data } = client.storage.from(bucket).getPublicUrl(path.join('/'))
   return data.publicUrl || ''
}
